import { fromJS } from 'immutable';

import { ApiUrl2,UserToken } from '../../../helper/HelperAuth'
import { GetMediaIdName } from '../../constants'
import doFetch from '../../../infra/helper/fetchHelper'

export default (page, search) => async (dispatch, getState) => {
    
    const Authorization = UserToken;
    
    const url = ApiUrl2 + 'find-media';
    if(page === undefined){
        page = 1;
    }
    var query = {
        "page":page,
        "page-size":10,
        "order-by":1,
        "order":"DESC",
        "search":search,
    }
    var paramBody = {
        "query": query
    };

    const argument = {  
        method: 'POST',
        headers : {
            'Content-Type':'application/json',
            'Authorization': Authorization,
        },
        body : JSON.stringify(paramBody)
    };  

    const response = await doFetch(url,argument);
    var data = fromJS({});
    if(response.ok){
        data = fromJS(await response.json());
        data = data.get('query-result')
        data = data.get('data');
    }
//debugger
    dispatch({ type: GetMediaIdName, data: fromJS(data) });
};